import React from 'react';


export default function Progress({ step, totalSteps = 6 }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '24px',
      gap: '2px',
      padding: '8px 0'
    }}>
      {[...Array(totalSteps)].map((_, i) => {
        const stepNum = i + 1;
        const isActive = stepNum === step;
        const isCompleted = stepNum < step;

        return (
          <React.Fragment key={stepNum}>
            <div style={{
              position: 'relative',
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '15px',
              fontWeight: '900',
              color: isActive ? '#2d2d2d' : 'rgba(255, 255, 255, 0.9)',
              fontFamily: "'Fredoka One', 'Patrick Hand', cursive",
              background: isActive 
                ? '#9ae66e'
                : isCompleted 
                  ? '#6a5a8e' 
                  : '#8b7db8',
              border: isActive ? '3px solid #2d2d2d' : '2px solid rgba(0,0,0,0.25)',
              boxShadow: isActive ? '0 3px 0 #2d2d2d, 0 0 12px rgba(154,230,110,0.4)' : 'none',
              transform: isActive ? 'translateY(-3px) scale(1.15)' : 'none',
              transition: 'all 0.3s ease',
              zIndex: isActive ? 2 : 1
            }}>
              {stepNum}
            </div>
            {stepNum < totalSteps && (
              <div style={{
                width: '10px',
                height: '0px',
                borderTop: isCompleted 
                  ? '3px dotted #2d2d2d' 
                  : '3px dotted rgba(255,255,255,0.3)',
                margin: '0 1px'
              }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}